import { useMemo } from "react";
import sortBy from "lodash/sortBy";

import useAuth from "../useAuth";
import { useProject } from "../../contexts/project";

export default function useAvailableCostCenters() {
  const { user } = useAuth();
  const currentProject = useProject();

  return useMemo(() => {
    const costCenters = currentProject?.costCenters || [];
    const userCostCenterIds = user?.costCenterIds || [];
    const visibleCostCenters = userCostCenterIds.length > 0
      ? costCenters.filter(cc => userCostCenterIds.includes(String(cc.id)))
      : costCenters;

    return sortBy(visibleCostCenters, cc => (cc.costCenterName || "").toLowerCase());
  }, [currentProject?.costCenters, user?.costCenterIds]);
}
